import api, { handleApiResponse } from './api';
import { Project, ProjectFormData, ApiResponse } from '../types';

export const projectService = {
  // Crear un nuevo proyecto
  async create(projectData: ProjectFormData): Promise<Project> {
    const response = await api.post<ApiResponse<Project>>(
      '/project/create',
      projectData,
    );
    return handleApiResponse(response);
  },

  async getAll(): Promise<ProjectFormData[]> {
    const response = await api.get<ApiResponse<ProjectFormData[]>>(
      '/project/all',
    );
    return handleApiResponse(response);
  },

  async deleteById(id: number): Promise<void> {
    await api.delete<ApiResponse<null>>(`/project/${id}`);
  },

  async getById(id: number): Promise<ProjectFormData> {
    const response = await api.get<ApiResponse<ProjectFormData>>(
      `/project/${id}`,
    );
    return handleApiResponse(response);
  },

  async update(projectData: ProjectFormData): Promise<Project> {
    const response = await api.put<ApiResponse<Project>>(
      `/project/${projectData.id}`,
      projectData,
    );
    return handleApiResponse(response);
  },

  async getAllForPriceLists(): Promise<ProjectFormData[]> {
    const response = await api.get<ApiResponse<ProjectFormData[]>>(
      '/project/for-pricelists',
    );
    return handleApiResponse(response);
  },

  async getAllSimple(): Promise<
    Array<{
      id: number;
      name: string;
      workCategories: Array<{
        id: number;
        value: string;
      }>;
    }>
  > {
    const response = await api.get<
      ApiResponse<
        Array<{
          id: number;
          name: string;
          workCategories: Array<{
            id: number;
            value: string;
          }>;
        }>
      >
    >('/project/all/simple');
    return handleApiResponse(response);
  },
};

export default projectService;
